import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { book, cancel, findBooking } from "../services/api";
const bg2 = "/images/bg_2.png";
const gift1 = "/images/gift_1.png";
const gift2 = "/images/gift_2.png";
const calendar = "/images/calendar.png";

const Booking = ({ phone, schedule, onScheduleUpdate }) => {
  const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [availableDays, setAvailableDays] = useState([]);
  const [availableTimes, setAvailableTimes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [cancelled, setCancelled] = useState(false);

  // Находим существующую бронь пользователя
  const existingBooking = schedule?.find(
    (slot) => slot.subscriber_id !== null && slot.subscriber_id !== undefined
  );

  const monthNames = [
    "",
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];

  const monthNamesGenitive = [
    "",
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];

  // Группируем слоты по месяцам и дням
  useEffect(() => {
    if (!schedule || schedule.length === 0) return;

    // Если есть существующая бронь, подставляем её данные
    if (existingBooking && !selectedMonth) {
      setSelectedMonth(String(existingBooking.month));
      setSelectedDay(String(existingBooking.daypart));
      setSelectedTime(existingBooking.timepart);
      return;
    }

    // Получаем уникальные месяцы (преобразуем в строки для сравнения)
    const months = [
      ...new Set(schedule.map((slot) => String(slot.month))),
    ].sort((a, b) => parseInt(a) - parseInt(b));

    if (months.length > 0 && !selectedMonth) {
      setSelectedMonth(months[0]);
    }
  }, [schedule, selectedMonth, existingBooking]);

  // Обновляем доступные дни при выборе месяца
  useEffect(() => {
    if (!selectedMonth || !schedule) return;

    const days = schedule
      .filter((slot) => String(slot.month) === selectedMonth)
      .map((slot) => String(slot.daypart))
      .filter((day, index, self) => self.indexOf(day) === index)
      .sort((a, b) => parseInt(a) - parseInt(b));

    setAvailableDays(days);

    if (days.length > 0 && !selectedDay) {
      setSelectedDay(days[0]);
    } else if (selectedDay && !days.includes(selectedDay)) {
      setSelectedDay("");
      setSelectedTime("");
    }
  }, [selectedMonth, schedule, selectedDay]);

  // Обновляем доступное время при выборе дня
  useEffect(() => {
    if (!selectedDay || !selectedMonth || !schedule) return;

    const times = schedule
      .filter(
        (slot) =>
          String(slot.month) === selectedMonth &&
          String(slot.daypart) === selectedDay
      )
      .map((slot) => slot.timepart)
      .sort();

    setAvailableTimes(times);

    if (times.length > 0 && !selectedTime) {
      setSelectedTime(times[0]);
    } else if (selectedTime && !times.includes(selectedTime)) {
      setSelectedTime("");
    }
  }, [selectedDay, selectedMonth, schedule, selectedTime]);

  // Получаем уникальные месяцы из расписания
  const getAvailableMonths = () => {
    if (!schedule || schedule.length === 0) return [];
    return [...new Set(schedule.map((slot) => String(slot.month)))].sort(
      (a, b) => parseInt(a) - parseInt(b)
    );
  };

  const handleBook = async () => {
    setError("");

    if (!selectedMonth || !selectedDay || !selectedTime) {
      setError("Пожалуйста, выберите месяц, число и время");
      return;
    }

    // Находим выбранный слот
    const selectedSlot = schedule.find(
      (slot) =>
        String(slot.month) === selectedMonth &&
        String(slot.daypart) === selectedDay &&
        slot.timepart === selectedTime
    );

    if (!selectedSlot) {
      setError("Выбранный слот недоступен");
      return;
    }

    // Формируем meeting_time в формате YYYY-MM-DD HH:mm
    const year = selectedSlot.datepart.split("-")[0];
    const month = String(selectedSlot.month).padStart(2, "0");
    const day = String(selectedSlot.daypart).padStart(2, "0");
    const meetingTime = `${year}-${month}-${day} ${selectedSlot.timepart}`;

    setLoading(true);
    try {
      await book(phone, meetingTime);
      setLoading(false);

      // Сохраняем данные для страницы подтверждения
      sessionStorage.setItem("bookingDay", selectedSlot.daypart);
      sessionStorage.setItem(
        "bookingMonth",
        monthNamesGenitive[parseInt(selectedSlot.month)]
      );
      sessionStorage.setItem("bookingTime", selectedSlot.timepart);

      navigate("/booked");
    } catch (err) {
      setLoading(false);
      setError(err.message || "Произошла ошибка при бронировании");
    }
  };

  const handleCancel = async () => {
    if (!existingBooking) return;

    setError("");

    // Формируем meeting_time в формате YYYY-MM-DD HH:mm
    const year = existingBooking.datepart.split("-")[0];
    const month = String(existingBooking.month).padStart(2, "0");
    const day = String(existingBooking.daypart).padStart(2, "0");
    const meetingTime = `${year}-${month}-${day} ${existingBooking.timepart}`;

    setLoading(true);
    try {
      await cancel(phone, meetingTime);
      setLoading(false);
      setCancelled(true);
    } catch (err) {
      setLoading(false);
      setError(err.message || "Произошла ошибка при отмене бронирования");
    }
  };

  const availableMonths = getAvailableMonths();

  // Если нет доступных слотов
  if (!schedule || schedule.length === 0) {
    return (
      <div className="wrapper booking-wrapper">
        <div className="bg booking-bg">
          <img src={bg2} alt="bg" />
        </div>
        <div className="booking-container">
          <div className="form">
            <h2 className="title">Нет доступных слотов для бронирования</h2>
            <button className="button" onClick={() => navigate("/")}>
              Вернуться на главную
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wrapper booking-wrapper">
      <div className="bg booking-bg">
        <img src={bg2} alt="bg" />
      </div>

      <div className="gift gift-1">
        <img src={gift1} alt="gift 1" />
      </div>
      <div className="gift gift-2">
        <img src={gift2} alt="gift 2" />
      </div>

      <div className="booking-container">
        <div className="calendar-wrapper">
          <img src={calendar} alt="calendar" className="calendar-bg" />
          <div className="calendar-content">
            <div className="select-group">
              <label className="select-label">Выберите месяц</label>
              <div className="custom-select">
                <select
                  className="select"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  disabled={
                    loading || availableMonths.length === 0 || existingBooking
                  }
                >
                  {availableMonths.map((month) => (
                    <option key={month} value={month}>
                      {monthNames[parseInt(month)]}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="select-group">
              <label className="select-label">Выберите число</label>
              <div className="custom-select">
                <select
                  className="select"
                  value={selectedDay}
                  onChange={(e) => setSelectedDay(e.target.value)}
                  disabled={
                    loading || availableDays.length === 0 || existingBooking
                  }
                >
                  {availableDays.map((day) => (
                    <option key={day} value={day}>
                      {day}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="select-group">
              <label className="select-label">Выберите время</label>
              <div className="custom-select">
                <select
                  className="select"
                  value={selectedTime}
                  onChange={(e) => setSelectedTime(e.target.value)}
                  disabled={
                    loading || availableTimes.length === 0 || existingBooking
                  }
                >
                  {availableTimes.map((time) => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {existingBooking ? (
              <button
                className="button booking-button secondary"
                onClick={handleCancel}
                disabled={
                  loading ||
                  !selectedMonth ||
                  !selectedDay ||
                  !selectedTime ||
                  cancelled
                }
              >
                {loading
                  ? "Отмена..."
                  : cancelled
                  ? "Отменено"
                  : "Отменить бронь"}
              </button>
            ) : (
              <button
                className="button booking-button"
                onClick={handleBook}
                disabled={
                  loading || !selectedMonth || !selectedDay || !selectedTime
                }
              >
                {loading ? "Бронирование..." : "Забронировать"}
              </button>
            )}
          </div>
        </div>
      </div>
      {error && (
        <div className="error-toast" onClick={() => setError("")}>
          {error}
        </div>
      )}
    </div>
  );
};

export default Booking;
